import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Skeleton from 'components/Skeleton';

import { useUser } from 'providers/UserProvider';

const LoggedUserButton = dynamic(() => import('./LoggedUserButton'), {
  ssr: false,
});
const SignUpButton = dynamic(() => import('./SignUpButton'), {
  ssr: false,
});

const UserProfileDropdown = ({ gaEventCategory }) => {
  const { isLoggedIn, loadingLoggedInUser } = useUser();

  if (loadingLoggedInUser) {
    return (
      <div className="flex h-[70px] w-[104px] flex-col items-center gap-2">
        <Skeleton className="h-10 w-10 rounded-full" />
        <Skeleton className="rounded h-3 w-16" />
      </div>
    );
  }

  return (
    <div className="w-[104px]">
      {!loadingLoggedInUser &&
        (isLoggedIn ? (
          <LoggedUserButton gaEventCategory={gaEventCategory} />
        ) : (
          <SignUpButton gaEventCategory={gaEventCategory} />
        ))}
    </div>
  );
};

UserProfileDropdown.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default UserProfileDropdown;
